import React, { useEffect } from "react";
import ScrollToTop from "./components/ScrollToTop";
import AOS from "aos";
import "aos/dist/aos.css";
import AnimatedCursor from "react-animated-cursor";
import { ToastContainer } from "react-toastify";
import ContextProvider from "Context/ContextProvider";
import ScrollTopBehaviour from "components/ScrollTopBehaviour";
import HomeDark from "views/all-home-version/HomeDark";
import BgAnimation from "components/BgAnimation";

const App = () => {
  useEffect(() => {
    AOS.init({
      duration: 1200,
    });
  }, []);

  return (
    <>
      <AnimatedCursor
        innerSize={8}
        outerSize={44}
        color="255, 160, 1"
        outerAlpha={0.3}
        innerScale={0.7}
        outerScale={1.2}
      />

      <BgAnimation />
      <ScrollToTop />
      <ContextProvider>
        <ScrollTopBehaviour />
        <HomeDark />
      </ContextProvider>
      <ToastContainer />
    </>
  );
};

export default App;
